// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBcBMIRiwbhrtodPV9G3Wb1fBhn3Hz1W50",
    authDomain: "redkorps-homepage.firebaseapp.com",
    projectId: "redkorps-homepage",
    storageBucket: "redkorps-homepage.firebasestorage.app",
    messagingSenderId: "861543468383",
    appId: "1:861543468383:web:a63ea3f8fc845b9ccbbaea"
  };

// Firebase initialisieren
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);



// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


